import Seo from "@/components/Seo";
import { LegalShell } from "@/pages/Privacy";
import { business } from "@/data/site";

const sections = [
  {
    h: "Agreement",
    p: [
      "These Terms & Conditions govern your use of the Future Roofing and Repair website. By using this site, you agree to these terms. If you do not agree, please do not use the site.",
    ],
  },
  {
    h: "Estimates & Inspections",
    p: [
      "Free estimates are available. Inspections may have a fee. Any estimate provided is based on the information and conditions known at the time and may change if additional issues are discovered during the project. Pricing is provided upon request and is not listed on this website.",
    ],
  },
  {
    h: "Scheduling & Work",
    p: [
      "Project timelines depend on factors such as roof size, materials, weather, and project complexity. We will make reasonable efforts to keep you informed of scheduling and any changes.",
    ],
  },
  {
    h: "Payments & Deposits",
    p: [
      "We accept all major payment methods. Deposits may be required depending on the project. Specific payment terms will be outlined in your project agreement.",
    ],
  },
  {
    h: "Warranties",
    p: [
      "Workmanship warranties are available and depend on the project. Manufacturer warranties may apply to certain materials, and extended warranties may be available. Warranty details will be provided as part of your specific project agreement.",
    ],
  },
  {
    h: "Insurance Claims",
    p: [
      "We work with insurance companies and can assist with paperwork and meet with adjusters at your request. We do not control the decisions of insurance carriers, and approval of any claim is determined by your insurer.",
    ],
  },
  {
    h: "Website Content",
    p: [
      "Photos labeled as placeholders are sample images shown for illustration and will be replaced with real project photos. We strive for accuracy but make no guarantee that all content is error-free or current at all times.",
    ],
  },
  {
    h: "Limitation of Liability",
    p: [
      "This website is provided on an \"as is\" basis. To the fullest extent permitted by law, Future Roofing and Repair is not liable for any damages arising from your use of this website.",
    ],
  },
  {
    h: "Contact",
    p: [
      "Questions about these Terms & Conditions can be directed to Future Roofing and Repair at " +
        business.phone +
        " or " +
        business.email +
        ".",
    ],
  },
];

export default function Terms() {
  return (
    <>
      <Seo
        title="Terms & Conditions | Future Roofing and Repair"
        description="Terms & Conditions for Future Roofing and Repair, a family-owned roofing company serving Bucks County, PA."
      />
      <LegalShell title="Terms & Conditions" sections={sections} />
    </>
  );
}
